import React from "react";
import { useParams, useSearchParams, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CATEGORY_ROLES, canAccessCategory } from "@/lib/roles";
import EstimationForm from "@/components/estimation/EstimationForm";
import MechanicProgressForm from "@/components/estimation/MechanicProgressForm";

export default function EstimationFormPage() {
  const { category } = useParams();
  const [params] = useSearchParams();
  const { user } = useAuth();

  if (!CATEGORY_ROLES.includes(category)) return <Navigate to="/" replace />;
  // Users may only access categories they hold (admin => all).
  if (!canAccessCategory(user, category)) return <Navigate to="/" replace />;

  // New estimations for Mechanic use the percentage-based progress workflow.
  if (category === "mechanic") {
    return (
      <MechanicProgressForm
        key={`mechanic-${params.get("edit_id") || params.get("unit_number") || "new"}`}
        unitNumber={params.get("unit_number") || ""}
        editId={params.get("edit_id") || ""}
      />
    );
  }

  return (
    <EstimationForm
      key={`${category}-${params.get("edit_id") || "new"}`}
      category={category}
      unitNumber={params.get("unit_number") || ""}
      editId={params.get("edit_id") || ""}
    />
  );
}
